import type * as React from "react";

import { cn } from "~/lib/utils";

function Textarea({ className, ...props }: React.ComponentProps<"textarea">) {
  return (
    <textarea
      data-slot="textarea"
      className={cn(
        // Base: layout, sizing, shape, typography, transition
        "flex field-sizing-content min-h-16 w-full rounded-lg border px-2.5 py-2 text-base transition-colors outline-none",
        // Default colors
        "border-border bg-input/70",
        // Dark
        "dark:bg-input/30",
        // Placeholder
        "placeholder:text-muted-foreground",
        // Focus-visible
        "focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-3",
        // Disabled
        "disabled:bg-input/50 disabled:cursor-not-allowed disabled:opacity-50",
        // Dark + disabled
        "dark:disabled:bg-input/80",
        // Aria-invalid
        "aria-invalid:border-destructive aria-invalid:ring-destructive/20 aria-invalid:ring-3",
        // Dark + aria-invalid
        "dark:aria-invalid:border-destructive/50 dark:aria-invalid:ring-destructive/40",
        // Responsive
        "md:text-sm",
        className,
      )}
      {...props}
    />
  );
}

export { Textarea };
